// extracted by mini-css-extract-plugin
export default {"control":"Product_control__Gswi9","richText":"Product_richText__3V3xi"};